import { useCallback } from 'react';

import { useBoardPowerUpsContext } from './useBoardPowerUpsContext';

export function useEnabledPowerUps() {
  return useBoardPowerUpsContext(
    useCallback(({ enabledPowerUps }) => enabledPowerUps, []),
  );
}
